import { useStoreWithEqualityFn } from 'zustand/traditional';

import { RootState } from '../types.js';

import { useStoreApi } from './useStoreApi.js';

export function useStore(): RootState;
export function useStore<U>(
  selector: (state: RootState) => U,
  equalityFn?: (a: U, b: U) => boolean
): U;
export function useStore(selector?: any, equalityFn?: any) {
  return useStoreWithEqualityFn(useStoreApi(), selector, equalityFn);
}
